module.exports = __webpack_public_path__ + "static/sketch-b9e2505cf1ba700a5f72fe67ff73ec89.png";